export const GOOGLE_BASED_AUTH = "g";
export const PASSWORD_BASED_AUTH = "p";

// Environment Names
export const PRODUCTION = "PRODUCTION";
export const HURRICANE = "HURRICANE";
export const TORNADO = "TORNADO";
export const REVVTEST = "REVVTEST";
export const REVVDEV = "REVVDEV";
export const REVVAI = "REVVAI";
export const MARTINI = "MARTINI";
export const MOJITO = "MOJITO";
export const MOJITO_REPLICA = "MOJITO_REPLICA";
export const REVV_LZ_DEV = "REVV_LZ_DEV";
export const REVV_LZ_QA = "REVV_LZ_QA";
export const DEV_LZ_CLUSTER = "DEV_LZ_CLUSTER";
export const QA_LZ_CLUSTER = "QA_LZ_CLUSTER";
export const PROD_LZ_CLUSTER = "PROD_LZ_CLUSTER";
export const LOCAL = "LOCAL";

// Domain name in which Website runs
export const WEBSITE_DOMAIN_URL = {
  [PRODUCTION]: "https://www.revv.so",
  [HURRICANE]: "https://www.hurricane.revvsales.com",
  [TORNADO]: "https://www.tornado.revvsales.com",
  [MARTINI]: "https://www.martini.revvsales.com",
  [MOJITO]: "https://www.revvso.xyz",
  [MOJITO_REPLICA]: "https://api.cloudrevvzoom.com",
  [REVV_LZ_DEV]: "https://api.cloudrevvzoom.com",
  [REVV_LZ_QA]: "https://qa.lz-revv-dev.net",
  [REVVTEST]: "http://www.revvtest.xyz",
  [REVVDEV]: "http://www.revvdev.xyz",
  [REVVAI]: "https://revvai.revvdev.xyz",
  [DEV_LZ_CLUSTER]: "https://api.cloudrevvzoom.com",
  [QA_LZ_CLUSTER]: "https://api.lz-revv-dev.net",
  [PROD_LZ_CLUSTER]: "https://www.revv.so",
  [LOCAL]: "http://localhost:3002",
};

// Domain name in which app runs
export const DOMAIN_NAME = {
  [PRODUCTION]: "revv.so",
  [HURRICANE]: "hurricane.revvsales.com",
  [TORNADO]: "tornado.revvsales.com",
  [MARTINI]: "martini.revvsales.com",
  [MOJITO]: "revvso.xyz",
  [MOJITO_REPLICA]: "cloudrevvzoom.com",
  [REVV_LZ_DEV]: "cloudrevvzoom.com",
  [REVV_LZ_QA]: "lz-revv-dev.net",
  [REVVTEST]: "revvtest.xyz",
  [REVVDEV]: "revvdev.xyz",
  [REVVAI]: "revvai.revvdev.xyz",
  [DEV_LZ_CLUSTER]: "cloudrevvzoom.com",
  [QA_LZ_CLUSTER]: "lz-revv-dev.net",
  [PROD_LZ_CLUSTER]: "revv.so",
  [LOCAL]: "localhost:3000",
};

export const AUTH_COOKIE_DOMAIN = {
  [PRODUCTION]: "revv.so",
  [HURRICANE]: "hurricane.revvsales.com",
  [TORNADO]: "tornado.revvsales.com",
  [MARTINI]: "martini.revvsales.com",
  [MOJITO]: "revvso.xyz",
  [MOJITO_REPLICA]: "cloudrevvzoom.com",
  [REVV_LZ_DEV]: "cloudrevvzoom.com",
  [REVV_LZ_QA]: "lz-revv-dev.net",
  [REVVTEST]: "revvtest.xyz",
  [REVVDEV]: "revvdev.xyz",
  [REVVAI]: "revvai.revvdev.xyz",
  [DEV_LZ_CLUSTER]: ".cloudrevvzoom.com",
  [QA_LZ_CLUSTER]: "lz-revv-dev.net",
  [PROD_LZ_CLUSTER]: "revv.so",
  [LOCAL]: "localhost:3000",
};

// Auth Urls Mapping
export const AUTH_URL = {
  [PRODUCTION]: "https://www.revv.so/signin/",
  [HURRICANE]: "https://hurricane.revvsales.com/signin/",
  [TORNADO]: "https://tornado.revvsales.com/signin/",
  [MARTINI]: "https://martini.revvsales.com/signin/",
  [MOJITO]: "https://www.revvso.xyz/signin/",
  [MOJITO_REPLICA]: "https://api.cloudrevvzoom.com/signin/",
  [REVV_LZ_DEV]: "https://api.cloudrevvzoom.com/signin/",
  [REVV_LZ_QA]: "https://qa.lz-revv-dev.net/signin/",
  [REVVTEST]: "http://www.revvtest.xyz/signin/",
  [REVVDEV]: "http://www.revvdev.xyz/signin/",
  [REVVAI]: "https://revvai.revvdev.xyz/signin/",
  [DEV_LZ_CLUSTER]: "https://auth.cloudrevvzoom.com/signin/",
  [QA_LZ_CLUSTER]: "https://auth.lz-revv-dev.net/signin/",
  [PROD_LZ_CLUSTER]: "https://www.revv.so/signin/",
  [LOCAL]: "http://localhost:3001/signin/",
};

export const DEFAULT_AUTH_REDIRECTION_URL = "pipeline";
export const DEFAULT_AUTH_REDIRECTION_URL_FREE_PLAN = "assets";

export const SIGNUP_QESTIONS_MAP = {
  Q11: "Executive Management (CEO, CFO, CRO)",
  Q12: "Senior Sales Management (VP, Director)",
  Q13: "Sales Operations (VP Sales Ops, Director, Manager)",
  Q14: "Front Line Sales (Field Sales, Inside Sales, Channel Sales)",
  Q21: "Contract management",
  Q22: "Quotation Creation",
  Q23: "Granular real time visibility into the deals",
  Q24: "Increasing velocity of approvals",
  Q25: "Cross team collaboration (legal, finance)",
  Q26: "Increase ROI from the sales tech stack/ CRM",
  Q31: "Show me everything you’ve got",
  Q32: "I’ve got 6 minutes or less.",
  Q33: "Wow me in less than 2 minutes.",
};

export const SIGNUP_USER_ROLE = {
  R1: "Contract Management",
  R2: "Quoting Software",
  R3: "Templates and Documents",
  R4: "Proposal Software",
};

export const USER_ROLES = [
  {
    label: SIGNUP_USER_ROLE.R2,
    value: SIGNUP_USER_ROLE.R2,
  },
  {
    label: SIGNUP_USER_ROLE.R4,
    value: SIGNUP_USER_ROLE.R4,
  },
  {
    label: SIGNUP_USER_ROLE.R1,
    value: SIGNUP_USER_ROLE.R1,
  },
  {
    label: SIGNUP_USER_ROLE.R3,
    value: SIGNUP_USER_ROLE.R3,
  },
];

export const SIGNUP_ONBOARD_CHECKLIST = {
  pricebooks: true,
  products: true,
  templates: true,
};
